import { Head } from "@shared/components/head";
import Button from "@shared/components/md-design-system/Button/Button";
import { View } from "react-native";
import { ActivityName } from "../../types";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { useForm } from "@shared/hooks";
import { Input } from "@shared/components/md-design-system/Input";
import { MEASUREMENT_FORM_INPUTS } from "../../constants/measurementForm";
import { usePost } from "app/queryProvider";
import { TMeasurementResponse, IPathwayMeasurementRequest } from "app/_modules/pathways/entities";
import { Loading } from "@shared/components/loading";
import { useAuth } from "app/auth/hooks/useAuth";

export const MeasurementForm = ({
    activityName,
    handleGoToMeasurementStep
}: {
    activityName: ActivityName;
    handleGoToMeasurementStep: () => void;
}) => {
    const { title, inputs } = MEASUREMENT_FORM_INPUTS[activityName as Exclude<ActivityName, ActivityName.ECG>];
    const { t } = dynamicTranslations();
    const { meData } = useAuth()


    const { mutate: createMeasurement, isPending: isCreatingMeasurement } = usePost<IPathwayMeasurementRequest, TMeasurementResponse>({
        options: {
            onSuccess: () => {
                handleGoToMeasurementStep();
            },
        }
    });

    const telemonitoringPathwayId = meData?.current_pathway.id || "";
    const type = activityName

    const { form, Form, formFields, submitForm } = useForm({
        inputs,
        onSubmit: async (values) => {
            const payload = {
                telemonitoringPathwayId,
                type,
                timestamp: new Date().toISOString(),
                measurement: {
                    ...values
                }
            }

            createMeasurement({
                resource: { name: "pathways", id: telemonitoringPathwayId },
                url: "/manual-measurement",
                data: payload,
            });
        },
    });

    if (isCreatingMeasurement) {
        return <Loading message={t("commons.loading.sendingMeasurement")} />
    }

    return (
        <View className="grow flex-col justify-between gap-4">
            <View className="flex-col gap-4">
                <Head type="h2">{t(title)}</Head>
                <Form form={form}>
                    <View className='flex-col gap-4 bg-white'>
                        {formFields.map((field) => (
                            <View key={field.name} className='flex-col gap-2 bg-white'>
                                <Form.Item
                                    name={field.name}
                                    rules={field.rules}
                                    noStyle
                                >
                                    <Input {...field} />
                                </Form.Item>
                            </View>
                        ))}
                    </View>
                </Form>
            </View>
            <Button onPress={submitForm} disabled={isCreatingMeasurement}>
                {t("buttons.save")}
            </Button>
        </View>
    );
};